import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation newNpoReportAnswerValidation(
    $answerId: Int!,
    $validationId: Int!,
    $hidden: Boolean,
  ) {
    newNpoReportAnswerValidation(
      answerId: $answerId,
      validationId: $validationId,
      hidden: $hidden,
    ) {
      id
      success
    }
  }
`;

export function useNewNpoReportAnswerValidation() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNpoReportAnswerValidation.id);
      }
    });
  };
  return { data, isLoading, run };
}
